import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, Phone } from "lucide-react";

const links = [
  { label: "Difference", href: "#difference" },
  { label: "Treatments", href: "#treatments" },
  { label: "About", href: "#about" },
  { label: "Visit", href: "#contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-[#FDFBF7]/85 backdrop-blur-md border-b border-[#E8DFD8]" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-5 flex items-center justify-between">
        <a href="#top" data-testid="brand-link" className="flex items-baseline gap-2">
          <span className="font-serif text-2xl tracking-tight text-[#2D2926]">Derma</span>
          <span className="eyebrow text-[#C89F95]">Aesthetic Studio</span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="hover-line text-sm tracking-wide text-[#5C5753] hover:text-[#2D2926] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="tel:0459830505"
            data-testid="navbar-call-btn"
            className="flex items-center gap-2 text-xs uppercase tracking-[0.22em] text-[#5C5753] hover:text-[#C89F95] transition-colors"
          >
            <Phone size={14} strokeWidth={1.5} /> 0459 830 505
          </a>
          <a
            href="#book"
            data-testid="navbar-book-btn"
            className="text-xs uppercase tracking-[0.22em] bg-[#C89F95] hover:bg-[#B3867B] text-white px-5 py-3 rounded-sm transition-colors"
          >
            Book Now
          </a>
        </div>

        <button
          data-testid="navbar-mobile-toggle"
          onClick={() => setOpen(!open)}
          className="md:hidden p-2 text-[#2D2926]"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} strokeWidth={1.5} /> : <Menu size={22} strokeWidth={1.5} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="md:hidden bg-[#FDFBF7] border-t border-[#E8DFD8] overflow-hidden"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {links.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                  className="text-sm tracking-wide text-[#5C5753]"
                >
                  {l.label}
                </a>
              ))}
              <a
                href="#book"
                onClick={() => setOpen(false)}
                data-testid="mobile-book-btn"
                className="mt-2 text-xs uppercase tracking-[0.22em] bg-[#C89F95] text-white px-5 py-3 rounded-sm text-center"
              >
                Book Now
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
